/* =========================
    IMPORTS & CORE PACKAGES
   ========================= */
import { db } from "../firebase";
import { collection, doc, setDoc, getDocs, limit, query } from "firebase/firestore";

/* =========================================
    DATABASE SCHEMA INITIALIZER & SEED DATA
   ========================================= */

/* Define Real Academic Seed Data */
export async function initializeDatabase() {
  const schemaCollections = [
    { 
      name: "users", 
      id: "admin_coord_01",
      data: { 
        uid: "system_admin", 
        fullName: "Academic Coordinator", 
        role: "admin", 
        status: "approved", 
        customId: "@ADMIN",
        createdAt: new Date().toISOString()
      } 
    },
    { 
      name: "courses", 
      id: "react_web_dev",
      data: { 
        code: "CO-SE-01", 
        name: "Diploma in Software Engineering", 
        status: "active",
        createdAt: new Date().toISOString()
      } 
    },
    { 
      name: "batches", 
      id: "se_batch_01",
      data: { 
        batchName: "Batch-01", 
        courseId: "react_web_dev", 
        courseFee: "45000",
        createdAt: new Date().toISOString()
      } 
    },
    { 
      name: "materials", 
      id: "syllabus_notes_01",
      data: { 
        title: "Introduction and Environment Setup Notes", 
        link: "https://react.dev", 
        youtubeLink: "https://www.youtube.com/@Oncodetech",
        courseId: "CO-SE-01", 
        batchId: "Batch-01",
        uploadedAt: new Date().toISOString()
      } 
    },
    { 
      name: "attendance", 
      id: "attendance_init",
      data: { 
        date: "2026-07-10", 
        records: {}, 
        batchId: "Batch-01",
        markedBy: "System Administrator",
        timestamp: new Date().toISOString()
      } 
    },
    { 
      name: "assessments", 
      id: "react_basics_quiz",
      data: { 
        title: "React Components and Props MCQ Quiz", 
        courseId: "CO-SE-01",
        batchName: "Batch-01",
        deadline: "2026-07-20T23:59",
        assessmentType: "mcq",
        gradingType: "auto",
        questions: [
          {
            questionText: "What is React?",
            options: ["A JavaScript library", "A database system", "An operating system", "A programming language"],
            correctOptionNum: "1",
            marks: "10"
          }
        ],
        totalMarks: 10,
        createdAt: new Date().toISOString()
      } 
    },
    { 
      name: "submissions", 
      id: "submission_init",
      data: { 
        assessmentId: "react_basics_quiz",
        assessmentTitle: "React Components and Props MCQ Quiz",
        studentId: "student_init_uid",
        studentName: "Sample Student Profile",
        studentAnswer: "{\"0\":\"A JavaScript library\"}",
        score: 100,
        status: "graded",
        feedback: "Auto-graded successfully",
        courseCode: "CO-SE-01",
        timestamp: new Date().toISOString()
      } 
    },
    { 
      name: "fees", 
      id: "fee_init_invoice",
      data: { 
        studentId: "@STD001", 
        courseCode: "CO-SE-01",
        courseName: "Diploma in Software Engineering (React & Firebase)",
        batchName: "Batch-01",
        amount: 45000, 
        status: "Pending", 
        paymentMethod: "N/A",
        paidDate: "",
        createdAt: new Date().toISOString()
      } 
    },
    { 
      name: "announcements", 
      id: "welcome_broadcast_01",
      data: { 
        title: "Welcome to Oncode Academic Platform", 
        content: "The Academic Performance & Tracking System is now fully functional. Enjoy your learning journey!", 
        targetType: "all", 
        targetRole: "all",
        publishedBy: "System Administrator",
        publishedByRole: "admin",
        timestamp: new Date().toISOString() 
      } 
    },
    { 
      name: "auditLogs", 
      id: "audit_init_log",
      data: { 
        action: "System Initialize", 
        details: "Database schema generated successfully with realistic seed data", 
        timestamp: new Date().toISOString() 
      } 
    }
  ];

  /* Collection Seeding Logic */
  for (const col of schemaCollections) {
    const colRef = collection(db, col.name);
    const q = query(colRef, limit(1));
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      await setDoc(doc(db, col.name, col.id), col.data);
      console.log(`Successfully generated dynamic collection: ${col.name}`);
    }
  }
}